import React from "react";
import styles from "./personPageBio.module.css"
import { useOutletContext } from "react-router-dom";
import {PersonFull} from "../../types/personTypes";

const PersonPageBio: React.FC = () => {
    const person = useOutletContext() as PersonFull;
    function text() {
        return {__html: person.description};
    }

    return (
        <section className={styles.bio}>
            <h2>Биография</h2>
            <div className={styles.bio_text} dangerouslySetInnerHTML={text()}>
            </div>
        </section>


    )
}

export default PersonPageBio;